import { createSlice } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  dateRange: {
    dt1: '',
    dt2: '',
    textValue: ''
  },
  filter: {
    SN: '',
    SN2: '',
    ixProd: 0
  },
  showSN: false,
  showSN2: false,
  page: 1,
  limit: 500,
  result: [],
  allLoaded: false
};
const slice = createSlice({
  name: 'snLogs',
  initialState: INITIAL_STATE,
  reducers: {
    // Catch-all multi-field setter
    setFields(state, action) {
      Object.keys(action.payload).forEach(key => {
        if (key in INITIAL_STATE) {
          state[key] = action.payload[key];
        } else {
          console.warn(
            `Property "${key}" does not exist in INITIAL_STATE of snLogs.`
          );
        }
      });
    },

    // Individual per-state property reducers
    setDateRange(state, action) {
      state.dateRange = action.payload;
    },
    setFilter(state, action) {
      // Replaces the whole filter or merges changes depending on preference
      // Standardizing here to deep merge so it behaves safely like the rest
      state.filter = { ...state.filter, ...action.payload };
    },
    setShowSN(state, action) {
      state.showSN = action.payload;
    },
    setShowSN2(state, action) {
      state.showSN2 = action.payload;
    },
    setPage(state, action) {
      state.page = action.payload;
    },
    setLimit(state, action) {
      state.limit = action.payload;
    },
    setResult(state, action) {
      state.result = action.payload;
    },
    setAllLoaded(state, action) {
      state.allLoaded = action.payload;
    },

    // Individual property resets/clears (following "set<<State>>" normalization)
    setFilterReset(state) {
      state.filter = INITIAL_STATE.filter;
    },
    setResultClear(state) {
      state.result = [];
    },

    // The lone wolf reset
    resetAll() {
      return INITIAL_STATE;
    }
  }
});

const snLogsReducer = slice.reducer;

export const {
  setFields,
  setDateRange,
  setFilter,
  setShowSN,
  setShowSN2,
  setPage,
  setLimit,
  setResult,
  setFilterReset,
  setResultClear,
  resetAll
} = slice.actions;

export default snLogsReducer;
